import { enumToOptions } from '@app/shared/helpers';
import { Sector } from '@app/shared/models/contracts/enums/shared-enums';

export const SECTOR_OPTIONS = enumToOptions(Sector, undefined, true);
